"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UK_COUNTRY_ID = exports.ANY_COUNTRY_ID = exports.INTEGRATION_TESTS_API_PARTNER_WITH_GBP_IN_UK = exports.INTEGRATION_TESTS_API_PARTNER_WITH_USD_GLOBALLY = exports.TRIPMASTERS_STAG_API_PARTNER_ID = exports.TRIPMASTERS_PROD_API_PARTNER_ID = exports.TWELVEGOASIA_STAG_API_PARTNER_ID = exports.TWELVEGOASIA_PROD_API_PARTNER_ID = exports.MOZIO_STAG_API_PARTNER_ID = exports.MOZIO_PROD_API_PARTNER_ID = exports.HEYTRIP_STAG_API_PARTNER_ID = exports.HEYTRIP_PROD_API_PARTNER_ID = exports.ATT_STAG_API_PARTNER_ID = exports.ATT_PROD_API_PARTNER_ID = void 0;
// Airport Taxi Transfers (ATT) partner IDs
// ATT partner receives order confirmation emails
// https://app.shortcut.com/daytrip/epic/57533/dynamic-email-flow-configuration-for-api-partners
exports.ATT_PROD_API_PARTNER_ID = "50d0d758-69c5-4f8b-8e57-d2bf6948ad5f";
exports.ATT_STAG_API_PARTNER_ID = "40e12f74-de3f-4988-97e2-9d4ef2592ea6";
// HeyTrip partner IDs
exports.HEYTRIP_PROD_API_PARTNER_ID = "8758c579-4952-458f-b4d7-0c947f6c83e3";
exports.HEYTRIP_STAG_API_PARTNER_ID = "bc926f64-b1e5-40e2-b8d1-4e1c89cfff91";
// Mozio partner IDs
exports.MOZIO_PROD_API_PARTNER_ID = "dfba8873-e49c-4b26-a505-0dc94365dbf7";
exports.MOZIO_STAG_API_PARTNER_ID = "58e10cb7-6a09-4146-aa5e-7cc9a2135c15";
// 12go.asia partner IDs
exports.TWELVEGOASIA_PROD_API_PARTNER_ID = "faac7039-75a0-424f-ace8-32b591810ae2";
exports.TWELVEGOASIA_STAG_API_PARTNER_ID = "64b85b7e-219c-486e-a00a-86cfd594b9b8";
// TripMasters partner IDs
exports.TRIPMASTERS_PROD_API_PARTNER_ID = "6a97c611-da51-4aaa-856c-85073fa31f10";
exports.TRIPMASTERS_STAG_API_PARTNER_ID = "80f97afa-d53a-46ed-87cb-8d576789c6fa";
// Integration test partner IDs
exports.INTEGRATION_TESTS_API_PARTNER_WITH_USD_GLOBALLY = "29c1b6ab-1982-4f98-a1a8-b2f1310ffcb4";
exports.INTEGRATION_TESTS_API_PARTNER_WITH_GBP_IN_UK = "f50506c4-2734-452d-9037-fede11f9b632";
// Country IDs for currency resolution
exports.ANY_COUNTRY_ID = "*";
exports.UK_COUNTRY_ID = "40aaa519-fcf8-42cd-a799-d9ec4cd4d9c6";
//# sourceMappingURL=api-partners-prod-ids.js.map